export const roles = [
  'Admin',
  'User',
  'ListMessage',
  'PatronDatabase',
  'Transactional'
]